<!-- src/app/upcoming-payments/upcoming-payments.component.html -->

<ng-container *ngIf="pending() as pdItems; else noData">
  <mat-card *ngIf="pdItems.length; else nonePending" class="pending-payments-card">
    <mat-card-title>Scheduled Payments</mat-card-title>
    <mat-card-content>
      <table mat-table [dataSource]="pdItems">

        <!-- ID -->
        <ng-container matColumnDef="rowId">
          <th mat-header-cell *matHeaderCellDef>#</th>
          <td mat-cell *matCellDef="let x">{{ x.rowId }}</td>
        </ng-container>

        <!-- Billing Type -->
        <ng-container matColumnDef="type">
          <th mat-header-cell *matHeaderCellDef>Type</th>
          <td mat-cell *matCellDef="let x">
            {{ x.billingType === 1 ? 'One-time' : 'Recurring' }}
          </td>
        </ng-container>

        <!-- Input Date -->
        <ng-container matColumnDef="inputDate">
          <th mat-header-cell *matHeaderCellDef>Input Date</th>
          <td mat-cell *matCellDef="let x">{{ x.inputDate | date:'shortDate' }}</td>
        </ng-container>

        <!-- Next Billing Date -->
        <ng-container matColumnDef="nextBillingDate">
          <th mat-header-cell *matHeaderCellDef>Scheduled Date</th>
          <td mat-cell *matCellDef="let x">{{ x.nextDate | date:'shortDate' }}</td>
        </ng-container>

        <!-- Amount -->
        <ng-container matColumnDef="amount">
          <th mat-header-cell *matHeaderCellDef>Amount</th>
          <td mat-cell *matCellDef="let x">
            <ng-container *ngIf="x.billingType === 0; else showAmount">
              Billing
            </ng-container>
            <ng-template #showAmount>
              {{ x.amountFixed | currency }}
            </ng-template>
          </td>
        </ng-container>


        <!-- Actions Column -->
        <ng-container matColumnDef="actions">
          <th mat-header-cell *matHeaderCellDef>Actions</th>
          <td mat-cell *matCellDef="let x" class="actions-cell">
            <div class="action-buttons">
              <button mat-icon-button color="primary" aria-label="Edit payment" (click)="onEdit(x)">
                <mat-icon>edit</mat-icon>
              </button>
              <button mat-icon-button color="warn" aria-label="Cancel payment" (click)="onCancel(x)"
                [disabled]="isCanceling(x)">
                <mat-icon *ngIf="!isCanceling(x)">cancel</mat-icon>
                <mat-progress-spinner *ngIf="isCanceling(x)" mode="indeterminate" diameter="20"></mat-progress-spinner>
              </button>
            </div>
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
      </table>
    </mat-card-content>
  </mat-card>
</ng-container>

<ng-template #nonePending>
  <p class="no-pending">No pending ACH payments.</p>
</ng-template>

<ng-template #noData>
  <p>Please select a loan to view pending payments.</p>
</ng-template>